import { Link } from "react-router-dom";

export default function FAQ({ getMData, getAutoSignalData }) {
    return (
        <><h3>FAQs</h3>
            <div className='today-faqs'>
                <h3>What is market activity?</h3>

                <p>Market activity is activity of various buying selling in stock market like Future and option, equity cash, commodity by various stock market player like FII, DII, Retail traders, professional etc.</p>

                <h3>What are the activities of primary market?</h3>

                <p>The primary market is where securities are created. In the primary market, companies sell new stocks and bonds to the public for the first time, such as with an initial public offering (IPO).</p>



                <h3>What is after market activity?</h3>

                <p>After-hours trading, as the name suggests, takes place after the markets close.</p>



                <h3>What is the current stock market doing today?</h3>
                <table className='table table-bordered'>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>LTP</th>
                            <th>CHG</th>
                            <th>%CHG</th>
                        </tr>
                    </thead>
                    <tbody>
                        {getMData && getMData.map((item, key) => (
                            <tr key={`global-key-${key}`}>
                                <td>{item.name}</td>
                                <td>{item.l}</td>
                                <td>{item.c}</td>
                                <td>{item.cp}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>


                {getAutoSignalData && <>
                    <h3>Which is the best share to buy today?</h3>

                    <table className='table table-bordered'>
                        <thead>
                            <tr>
                                <th>Symbol</th>
                                <th>LTP</th>
                                <th>Open</th>
                                <th>Low</th>
                                <th>Volume</th>
                                <th>CHG</th>
                                <th>%CHG</th>
                            </tr>
                        </thead>
                        <tbody>
                            {getAutoSignalData && getAutoSignalData.map((item, key) => (
                                <tr key={`global-auto-key-${key}`}>
                                    <td><Link
                                        to={`/stocks/${item.symbol}-share-price`}
                                    >
                                        {item.symbol}
                                    </Link> </td>
                                    <td>{item.l}</td>
                                    <td>{item.op}</td>
                                    <td>{item.lo}</td>
                                    <td>{item.vo}</td>
                                    <td>{item.c}</td>
                                    <td style={{ color: item.cp < 0 ? "red" : "green" }}>{item.cp}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>}


                <h3>What is trending in market?</h3>

                <p>A price series that continually closes either higher or lower (on average over a defined number of periods) is said to be trending. An upward trending market is one that may fluctuate up and down but on average tends to close periodically higher.</p>



                <h3>Is the market working today?</h3>

                <p>NSE or National Stock Exchange is open on the weekdays from Monday to Friday and is closed on Saturday and Sunday, except for any special trading sessions that are announced.</p>



                <h3>What is market making activity?</h3>

                <p>A market maker participates in the market at all times, buying securities from sellers and selling securities to buyers. Market makers provide liquidity, which ensures investors can trade quickly and at a fair price in all conditions.</p>



                <h3>What is happening on the stock market today?</h3>

                <p>Show top 5 market listing symbol</p>

                <h3>Can I buy shares after 3.30 pm?</h3>

                <p>No, only order can be placed which will be executed next trading day.</p>

                <h3>Which share to buy tomorrow?</h3>

                <p>Show top 5 most active share from Auto signal “unusual volume” box.</p>

                <h3>Is it wise to invest in share market now?</h3>

                <p>The best time to buy stocks is when the share prices of a given stock are at a low and formed bottom in last six months .</p>



                <h3>Why is the stock market important today?</h3>

                <p>The stock market is a component of a free-market economy. It allows companies to raise money by offering stock shares and corporate bonds and allows investors to participate in the financial achievements of the companies, make profits through capital gains, and earn income through dividends.</p>

            </div>
        </>
    )
}
